export const insertIdIntoCode = (code: string, id: string) => {
  return code.replace(/{{id}}/g, id).replace(/#thisComponent/g, `${id}`);
}
